export class EmailPayloadBase {
  static $type = 'emailPayloadBase';
  $type: string;
  organisationName: string;
  organisationEmail: string;
  organisationPhone: string;

  constructor(data: Partial<EmailPayloadBase> = {}) {
    this.$type = (this.constructor as typeof EmailPayloadBase).$type;

    this.organisationName = data.organisationName ?? '';
    this.organisationEmail = data.organisationEmail ?? '';
    this.organisationPhone = data.organisationPhone ?? '';
  }
}
